import { useMutation } from '@tanstack/react-query';
import { useFactGrabbingStore } from 'features/fact-grabbing/useFactGrabbingStore';
import { httpGetClaimsByText } from 'services/backofficeIntegration/http/endpoints/fact-grabbing/httpGetClaimsByText';

type FetchClaimsOptions = {
  text: string;
  noCache?: boolean;
};

export const useFactGrabbingService = () => {
  const { setClaims, setLoading, setError, getCachedClaims } = useFactGrabbingStore();

  const { mutate, isLoading, isError } = useMutation({
    mutationFn: async (text: string) => httpGetClaimsByText.callEndpoint(text),
    onSuccess: (claims, text) => {
      setClaims(text, claims);
      setLoading(false);
      setError(false);
    },
    onError: () => {
      setLoading(false);
      setError(true);
    }
  });

  const fetchClaims = ({ text, noCache }: FetchClaimsOptions) => {
    if (!noCache) {
      // Use cached claims if available
      const cachedClaims = getCachedClaims(text);
      if (cachedClaims) {
        return;
      }
    }

    setLoading(true);
    setError(false);
    mutate(text);
  };

  return {
    fetchClaims,
    isLoading,
    isError
  };
};
